import type { ApprovalDecision } from "@/lib/decide-approval";
import type { WorkToastApproval } from "@/stores/work-toast-store";
import { useT } from "@/i18n";
import { toastsMessages } from "@/i18n/messages/toasts";
import { ToastActionButton } from "./toast-pill";

export function WorkToastApprovalBody({
  approval,
  disabled,
  onDecide,
}: {
  approval: WorkToastApproval;
  disabled: boolean;
  onDecide: (decision: ApprovalDecision) => void;
}) {
  const t = useT(toastsMessages);
  return (
    <>
      <p className="text-appkit-body text-primary">{approval.title}</p>
      {approval.description && (
        <p className="whitespace-pre-wrap break-words text-appkit-small text-muted">
          {approval.description}
        </p>
      )}
      <div className="flex justify-end gap-1.5">
        <ToastActionButton
          action={{
            id: "deny",
            label: t("deny"),
            disabled,
            onClick: () => onDecide("reject"),
          }}
        />
        <ToastActionButton
          action={{
            id: "allow",
            label: t("allow"),
            disabled,
            onClick: () => onDecide("approve"),
          }}
        />
      </div>
    </>
  );
}
